// extracted by mini-css-extract-plugin
module.exports = {"auth-code__container":"AuthCodeInput_auth-code__container__E9_LZ","auth-code__input":"AuthCodeInput_auth-code__input__DcwtM"};